import gsap from 'gsap'
import { useRef } from 'react'

export function useCardHoverFlip(enableHoverFlip: boolean) {
  const cardRefs = useRef<(HTMLDivElement | null)[]>([])

  const handleCardHover = (index: number) => {
    if (!enableHoverFlip) return

    const el = cardRefs.current[index]
    if (!el) return

    gsap.fromTo(
      el,
      { rotateY: 0 },
      { rotateY: 720, duration: 1.2, ease: 'power2.inOut' }
    )
  }

  return { cardRefs, handleCardHover }
}
